export const en = {
    'titles': {
        settings: 'Settings',
        support: 'Support',
        dashboard: 'Dashboard',
        organisations: 'Organisations',
        network: 'Network',
        organisationsList: 'Liste des Organisations',
        clientList: 'Liste des Clients',
        commercialList: 'Liste des Commerciaux',
        domainList: 'Liste des secteurs d\'activités',
        functionnalityList: 'Liste des fonctionnalités',
        moduleList: 'Liste des modules',
        typePacksList: 'Liste des types packs',
        packsList: 'Liste des packs',
        light: 'Light',
        displayed: 'Displayed',
    }
};
